export default __webpack_public_path__ + "static/media/BlackRightArrow.2fe8040b.svg";